document.addEventListener('DOMContentLoaded', () => {
  function setupWaitlistModal() {
    const waitlistOpeners = document.querySelectorAll('.waitlist-button-container');
    
    waitlistOpeners.forEach(opener => {
      opener.addEventListener('click', () => {
        const modalId = opener.getAttribute('data-modal');
        const modal = document.querySelector(modalId);
        
        if (!modal) return;
        
        setTimeout(() => {
          const productTitle = document.querySelector('.wt-product__name')?.textContent.trim();
          
          let variantSku = '';
          
          const skuElement = document.querySelector('.wt-product__sku');
          if (skuElement) {
            variantSku = skuElement.textContent.replace(/Item #/, '').trim();
          }
          
          if (!variantSku) {
            const variantSelect = document.querySelector('select[name="id"]');
            const variantInput = document.querySelector('input[name="id"]');
            
            if (variantSelect) {
              const selectedOption = variantSelect.options[variantSelect.selectedIndex];
              const variantId = selectedOption.value;
              variantSku = `ID: ${variantId}`;
            } else if (variantInput) {
              const variantId = variantInput.value;
              variantSku = `ID: ${variantId}`;
            }
          }
          
          const nameField = modal.querySelector('#form-waitinglist-model_name');
          const skuField = modal.querySelector('#form-waitinglist-model_number');
          
          if (nameField) {
            nameField.value = productTitle;
          }
          
          if (skuField) {
            skuField.value = variantSku;
          }
        }, 500);
      });
    });
  }
  
  setupWaitlistModal();
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        setupWaitlistModal();
      }
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});
